import { LinkResetDigestSurveyModel } from 'api/dto/LinkResetDigest.dto';
import { Resource } from 'model/Resource';
import { TakeLatestNew } from 'shared/utils/type';

export const STORE_NAME = 'linkResetDigest';

export namespace LinkResetDigestState {
  export type Domain = {
    /**
     * Take-latest: changing the date or the action filter fires a new request while the previous
     * one is still in flight, and the responses do not necessarily come back in order.
     */
    digest: TakeLatestNew<Resource<LinkResetDigestSurveyModel[] | null>>;
    emailPreference: Resource<boolean>;
  };

  export const INITIAL_DOMAIN: Domain = {
    digest: {
      data: Resource.createPendingResource<LinkResetDigestSurveyModel[]>(),
      requestId: '',
    },
    emailPreference: Resource.createPendingResource(),
  };
}

export type LinkResetDigestState = {
  linkResetDigest?: LinkResetDigestState.Domain;
};
